import React, { FC } from 'react';

import { Flex, Spinner } from '@chakra-ui/react';

import { Button, IButtonProps } from '../../../Button';
import { CheckIcon } from '../../../Icons';

interface IContinueButton extends IButtonProps {
  isLoading: boolean;
  isSuccess: boolean;
}

export const ContinueButton: FC<IContinueButton> = ({
  isLoading,
  isSuccess,
  ...restProps
}) => {
  return (
    <Button
      inverted
      height="54px"
      marginBottom="24px"
      marginTop="24px"
      width="100%"
      {...restProps}
    >
      <Flex alignContent="center">
        {isLoading ? (
          <Spinner size="sm" />
        ) : isSuccess ? (
          <CheckIcon />
        ) : (
          'Verify'
        )}
      </Flex>
    </Button>
  );
};
